import { styled } from 'stitches.config';

const footerWidth = 1000;

export const BannerWrapper = styled('div', {
  backgroundColor: 'white',
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  zIndex: 4,
  paddingTop: '70px',

  '@xs': {
    px: '$5',
  },
});

export const Banner = styled('div', {
  backgroundColor: '$colorGreyLv1',
  width: footerWidth,
  height: '325px',
  borderRadius: 16,
  padding: '0 102px',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '50px',

  position: 'relative',
  backgroundImage: 'url(/img/homepage/footer/shape-banner.png)',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  marginBottom: '-70px',

  '@md': {
    width: '88%',
    padding: '0 60px',
    gap: '30px',
  },

  '@xs': {
    width: '100%',
    flexDirection: 'column',
    padding: '120px 20px',
    height: 'auto',
    textAlign: 'center',
    marginBottom: '-160px',
  },

  button: {
    whiteSpace: 'nowrap',
  },
});

export const FirstCoin = styled('span', {
  position: 'absolute',
  right: 0,
  top: 0,
  transform: 'translateY(-50%)',
});

export const SecondCoin = styled('span', {
  position: 'absolute',
  left: 0,
  bottom: 0,
  transform: 'translateX(-50%)',
});

export const FooterWrapper = styled('footer', {
  backgroundColor: '$colorBackground',
  position: 'relative',
  zIndex: 3,

  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',

  pt: '127px',
  pb: '67px',

  variants: {
    withBanner: {
      true: {
        '@xs': {
          pt: '280px',
        },
      },
    },
  },
});

export const FooterContent = styled('div', {
  width: footerWidth,
  '@md': {
    width: '100%',
    padding: '0 40px',
  },
  '@xs': {
    textAlign: 'center',
    padding: 0,
  },
});

const dottedBorder = {
  position: 'relative',
  '&:before': {
    content: '',
    position: 'absolute',
    inset: 0,
    backgroundImage:
      'linear-gradient(to right, $colorGreyLv5 0%, $colorGreyLv5 10%, transparent 0%)',
    backgroundSize: '8px 1px',
    backgroundRepeat: 'repeat-x',
    backgroundPosition: 'bottom',
    opacity: 0.6,
    pointerEvents: 'none',
  },
};

export const LogoWrapper = styled('div', {
  ...dottedBorder,
  paddingBottom: '46px',
  '@xs': {
    textAlign: 'center',
    paddingBottom: '0',
    width: '82px',
    margin: 'auto',
    '&:before': {
      display: 'none',
    },
  },
});

export const LinksWrapper = styled('div', {
  ...dottedBorder,
  padding: '37px 0px 50px',
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '50px',
  '@md': {
    gap: 0,
  },
  '@xs': {
    gridTemplateColumns: '1fr',
    gap: '40px',
    '&:before': {
      display: 'none',
    },
  },

  a: {
    cursor: 'pointer',

    '&:hover': {
      color: '$textTertiaryAlt',
    },
  },
  'div:first-child': {
    gridColumn: 'span 2',
    '> span[type="button"]': {
      height: '25.59px',
    },
    ul: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    '@xs': {
      gridColumn: 'span 1',
      ul: {
        gridTemplateColumns: '1fr',
      },
    },
  },
});

export const SubsectionLinksWrapper = styled('ul', {
  marginTop: 8,
  paddingLeft: 16,
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  '@xs': {
    padding: 0,
    gap: 0,
    marginTop: 0,
    marginBottom: 16,
  },
});

export const LinkList = styled('ul', {
  display: 'grid',
  gap: '8px 50px',
  '@xs': {
    gap: 0,
    span: {
      justifyContent: 'center',
    },
  },
});

export const LastLineWrapper = styled('div', {
  ...dottedBorder,

  padding: '20px 0',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '20px',

  '@xs': {
    padding: '40px 0 20px',
    '&:before': {
      display: 'none',
    },
    ul: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 40px',
    },
  },
});

export const FlagsWrapper = styled('ul', {
  display: 'flex',
  alignItems: 'center',
  gap: 8,

  img: {
    cursor: 'pointer',
    borderRadius: '',
  },
});

export const SocialsWrapper = styled('ul', {
  display: 'flex',
  gap: '44px',
});

export const linkListTitle = {
  marginBottom: 16,
};
